import React from "react";

const FeatureInfo: React.FC = () => {
  const features = [
    {
      icon: "◈",
      title: "35+ Digital Courses",
      description: "Learn, Grow & Succeed",
      accent: "#00f6ff",
    },
    {
      icon: "◉",
      title: "Lifetime Access",
      description: "Education for a Brighter Tomorrow",
      accent: "#8b5cff",
    },
    {
      icon: "✦",
      title: "Soft Skills",
      description:
        "Mastering Soft Skills is Mastering the Art of Working with Hearts",
      accent: "#00f6ff",
    },
  ];

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #050810 0%, #080c18 50%, #050812 100%)",
        borderTop: "1px solid rgba(0,246,255,0.12)",
        borderBottom: "1px solid rgba(139,92,255,0.12)",
        boxShadow:
          "0 15px 50px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.025)",
      }}
    >
      {/* =========================================================
          BACKGROUND GRID
      ========================================================= */}

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          opacity: 0.07,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",
          backgroundSize: "35px 35px",
        }}
      />

      {/* =========================================================
          CYAN GLOW
      ========================================================= */}

      <div
        style={{
          position: "absolute",
          width: 350,
          height: 350,
          left: "-150px",
          top: "-220px",
          borderRadius: "50%",
          background: "rgba(0,246,255,0.08)",
          filter: "blur(100px)",
          pointerEvents: "none",
        }}
      />

      {/* =========================================================
          PURPLE GLOW
      ========================================================= */}

      <div
        style={{
          position: "absolute",
          width: 350,
          height: 350,
          right: "-150px",
          bottom: "-230px",
          borderRadius: "50%",
          background: "rgba(139,92,255,0.09)",
          filter: "blur(100px)",
          pointerEvents: "none",
        }}
      />

      {/* =========================================================
          CONTENT
      ========================================================= */}

      <div
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(260px, 1fr))",
          }}
        >
          {features.map((feature, index) => (
            <div
              key={feature.title}
              style={{
                position: "relative",
                minHeight: "205px",
                padding: "38px 30px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",

                borderRight:
                  index !== features.length - 1
                    ? "1px solid rgba(255,255,255,0.06)"
                    : "none",

                transition:
                  "transform 0.3s ease, background 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  "rgba(0,246,255,0.035)";
                e.currentTarget.style.transform =
                  "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  "transparent";
                e.currentTarget.style.transform =
                  "translateY(0)";
              }}
            >
              {/* =================================================
                  ICON
              ================================================= */}

              <div
                style={{
                  width: "58px",
                  height: "58px",
                  borderRadius: "16px",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  marginBottom: "17px",

                  fontSize: "27px",
                  fontWeight: 700,

                  color: feature.accent,

                  background:
                    "linear-gradient(135deg, rgba(0,246,255,0.08), rgba(139,92,255,0.07))",

                  border:
                    `1px solid ${feature.accent}35`,

                  boxShadow:
                    `0 0 25px ${feature.accent}12, inset 0 0 15px ${feature.accent}05`,

                  textShadow:
                    `0 0 12px ${feature.accent}80`,

                  transition:
                    "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                {feature.icon}
              </div>

              {/* =================================================
                  TITLE
              ================================================= */}

              <h4
                style={{
                  margin: "0 0 8px 0",

                  color: "#ffffff",

                  fontSize: "18px",
                  lineHeight: "1.35",

                  fontWeight: 700,

                  letterSpacing: "0.2px",

                  textShadow:
                    "0 2px 12px rgba(0,0,0,0.8)",
                }}
              >
                {feature.title}
              </h4>

              {/* =================================================
                  DESCRIPTION
              ================================================= */}

              <p
                style={{
                  margin: 0,

                  maxWidth: "330px",

                  color: "#cbd5e1",

                  fontSize: "13px",
                  lineHeight: "1.65",

                  fontWeight: 500,

                  textShadow:
                    "0 1px 8px rgba(0,0,0,0.8)",
                }}
              >
                {feature.description}
              </p>

              {/* =================================================
                  BOTTOM GLOW LINE
              ================================================= */}

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: "25%",
                  right: "25%",
                  height: "1px",

                  background:
                    `linear-gradient(90deg, transparent, ${feature.accent}60, transparent)`,

                  boxShadow:
                    `0 0 10px ${feature.accent}35`,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* =========================================================
          BOTTOM SCAN LINE
      ========================================================= */}

      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: "10%",
          right: "10%",
          height: "1px",

          background:
            "linear-gradient(90deg, transparent, rgba(0,246,255,0.5), rgba(139,92,255,0.4), transparent)",

          pointerEvents: "none",
        }}
      />

      {/* =========================================================
          RESPONSIVE STYLE
      ========================================================= */}

      <style>
        {`
          @media (max-width: 768px) {
            .feature-info-mobile {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 768px) {
            section {
              -webkit-tap-highlight-color: transparent;
            }
          }
        `}
      </style>
    </section>
  );
};

export default FeatureInfo;